import type { Dictionary } from '../dictionary.types'

const es: Dictionary = {
  ItemCountOfTotalCount: 'Elemento {{index}} de {{pagerCount}}',
  'Currently Active': 'Elemento activo',
}

export default es
